import styled from 'styled-components';

export const Pad = styled.div`
  background: white;
  border: none;
  max-width: 400px;
  width: 100%;
  min-height: 65px;
  border-radius: 16px;
  margin-top: 20px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;
